import script from "./bottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./bottom.vue?vue&type=script&lang=ts&setup=true"

import "./bottom.vue?vue&type=style&index=0&id=e82f5438&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e82f5438"]])

export default __exports__